(function (angular, isNaN, parseFloat, gsap, Expo) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyNumberAnimator", [
    "$filter",
    "$rootScope",
    function ($filter, $rootScope) {
      return {
        scope: {
          source: "<ngModel",
        },
        restrict: "E",
        template: '<span class="ty-number-animator-container" data-ng-bind-html="animatedValue"></span>',
        link: function (scope, element, attrs) {
          init(scope, element, attrs);
        },
      };

      function init(scope, elem, attrs) {
        scope.animatedValue = 0;
        scope.interimValue = { value: 0 };
        scope.formatter = attrs.formatter || "formatNumber";

        scope.$watch("source", function (newVal) {
          if (!isNaN(parseFloat(newVal))) {
            gsap.to(scope.interimValue, 1.0, {
              ease: Expo.easeOut,
              value: newVal,
              onUpdate: function () {
                var args = [scope.interimValue.value];

                if (attrs.formatterArgs) {
                  var argumentObject = JSON.parse(attrs.formatterArgs);
                  args = args.concat(
                    Object.keys(argumentObject).map(function (e) {
                      return argumentObject[e];
                    })
                  );
                }

                var formatter = $filter(scope.formatter);
                var returnValue = formatter.apply(null, args);

                scope.animatedValue = returnValue
                  .split("")
                  .map(function (digit) {
                    if (digit.match(/[0-9]/)) {
                      return (
                        '<span class="ty-number-animator-char ty-number-animator-char--digit">' + digit + "</span>"
                      );
                    }

                    return '<span class="ty-number-animator-char">' + digit + "</span>";
                  })
                  .join("");
                scope.$digest();
              },
              onComplete: function () {
                $rootScope.$broadcast("number-animator-finished", elem);
              },
            });
          }
        });
      }
    },
  ]);
})(window.angular, window.isNaN, window.parseFloat, window.gsap, window.Expo);
